module.exports = __webpack_public_path__ + "img/ea55878.jpg";